import { render, staticRenderFns } from "./Commandes.vue?vue&type=template&id=4bf34a5e&scoped=true"
import script from "./Commandes.vue?vue&type=script&lang=js"
export * from "./Commandes.vue?vue&type=script&lang=js"
import style0 from "./Commandes.vue?vue&type=style&index=0&id=4bf34a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf34a5e",
  null
  
)

export default component.exports